import { useCallback, useMemo, useState } from "react";

export enum WhatsappAssistantMode {
  General = "General",
  Voice = "Call",
  Chat = "Chat",
}

export default function useWhatsappAssistantMode() {
  const [activeMode, setActiveMode] = useState<WhatsappAssistantMode>(
    WhatsappAssistantMode.General
  );

  const whatsappAssistantModesAsTabs = useMemo(
    function () {
      return Object.values(WhatsappAssistantMode).map(function (mode) {
        return { name: mode, current: mode === activeMode, href: "#" };
      });
    },
    [activeMode]
  );

  const updateActiveMode = useCallback(function (e, { tab, index }) {
    setActiveMode(tab.name);
  }, []);

  const value = useMemo(
    function () {
      return {
        activeMode,
        whatsappAssistantModesAsTabs,
        updateActiveMode,
      };
    },
    [activeMode, whatsappAssistantModesAsTabs, updateActiveMode]
  );

  return value;
}
